import { Button } from "antd";
import styled from "styled-components";
import CustomTable from "../../components/CustomTable";


export const EmailBodyContainer = styled.div`
  padding: 12px;
  max-height: 250px;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  word-break: break-word;
  white-space: normal !important;
  
  * {
    white-space: normal !important;
  }
`;

export const ClaimButton = styled(Button)`
    padding: 0;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
`;

export const LogsDescription = styled.div`
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const LogsTable = styled(CustomTable)`
    .ant-table-tbody > tr > td {
      padding: 8px 16px;
    }
    
    .ant-table-expanded-row > td {
      white-space: normal !important;
    }
    
    .ant-table-expanded-row .ant-table-cell {
      overflow: visible;
    }
`;

export const ShowMoreButton = styled(Button)`
   min-width: 80px;
   width: 100%;
   border-radius: 0px;
   font-size: 14px;
   font-weight: 500;

   span{
    font-size: 14px !important; 
   }
`;